import { render, staticRenderFns } from "./shareholders.vue?vue&type=template&id=828a6c6c&"
import script from "./shareholders.vue?vue&type=script&lang=js&"
export * from "./shareholders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports